import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from "react-redux";
import {
    getIntersections,
    selectIntersections,
    selectIntersectionsLoading,
    selectRetryCount,
} from "./trafficInfraSlice";
import classes from './TrafficInfra.module.css';
import { isEmpty } from "../../util/utils";
import Spinner from "../ui/Spinner";

export const TrafficInfra = () => {
    const dispatch = useDispatch();
    const intersections = useSelector(selectIntersections);
    const intersectionsLoading = useSelector(selectIntersectionsLoading);
    const retryCount = useSelector(selectRetryCount);

    useEffect(() => {
        if (isEmpty(intersections) && !intersectionsLoading && retryCount === 0) {
            dispatch(getIntersections());
        }
    }, [dispatch, intersections, intersectionsLoading, retryCount]);

    const { t } = useTranslation();

    if (isEmpty(intersections)) {
        return (
            <div className={classes.TrafficInfraContainer}>
                <Spinner />
            </div>
        );
    }

    return (
        <div className={classes.TrafficInfraContainer}>
            <p onClick={() => dispatch(getIntersections())}>{t('infra.intersections_count')} <strong>{intersections['totalFeatures']}</strong></p>
        </div>
    );
};
